<div [class]="infoIconClass" [ngClass]="{ 'btv-icon-info': true }" (click)="tooltipHandler()">
  @if (isTooltipOpen) {
    <div [class]="contentClass">{{ text }}</div>
  }
</div>
